export const UI_START_LOADING = 'UI_START_LOADING';
export const UI_STOP_LOADING = 'UI_STOP_LOADING';
export const QUIZ_NEEDS_RELOAD = 'QUIZ_NEEDS_RELOAD';
export const HSPT_NEEDS_RELOAD = 'HSPT_NEEDS_RELOAD';
export const LOADER_TEXT = 'LOADER_TEXT';

export const AUTH_CURRENT_USER = 'AUTH_CURRENT_USER'
export const AUTH_SAVE_USER_DETAILS = 'AUTH_SAVE_USER_DETAILS'

export const QUESTIONS_BY_SECTION_ID = 'QUESTIONS_BY_SECTION_ID'
export const QUESTION_SELECTED_ANSWERS = 'QUESTION_SELECTED_ANSWERS'
export const CURRENT_USER_ALL_DATA = 'CURRENT_USER_ALL_DATA'
export const QUIZ_ANSWERS_BY_USER_QUIZ_ID = 'QUIZ_ANSWERS_BY_USER_QUIZ_ID'
export const UPDATE_QUIZ_ANSWERS = 'UPDATE_QUIZ_ANSWERS'
export const USER_START_QUIZ = 'USER_START_QUIZ'
export const USER_FINISH_QUIZ = 'USER_FINISH_QUIZ'

export const SAVE_COURSES = 'SAVE_COURSES'
export const SELECT_COURSE_FOR_CART = 'SELECT_COURSE_FOR_CART'

export const LIST_STUDENTS_BY_PARENTS = 'LIST_STUDENTS_BY_PARENTS'
export const LIST_STUDENTS_BY_FAMILY= 'LIST_STUDENTS_BY_FAMILY'
export const SELECTED_STUDENT = 'SELECTED_STUDENT'

export const CURRENT_USER_CART_DATA = 'CURRENT_USER_CART_DATA'
export const COUPON_RESULT = 'COUPON_RESULT'

export const LIST_TRANSACTIONS = 'LIST_TRANSACTIONS'

export const SAVE_MY_COURSE = 'SAVE_MY_COURSE'

export const LIST_USER_QUIZZES = 'LIST_USER_QUIZZES'

export const SELECTED_QUIZ_ID_FOR_SECTIONS = 'SELECTED_QUIZ_ID_FOR_SECTIONS'
export const LIST_QUIZ_SECTIONS = 'LIST_QUIZ_SECTIONS'
export const USER_FINISH_QUIZ_ID = 'USER_FINISH_QUIZ_ID'


//QUIZ
export const LIST_QUESTIONS_BY_SECTION_ID = 'LIST_QUESTIONS_BY_SECTION_ID'
export const SAVE_STARTED_QUIZ = 'SAVE_STARTED_QUIZ'
export const SELECTED_QUIZ = 'SELECTED_QUIZ'
export const SELECTED_QUIZ_SECTIONS = 'SELECTED_QUIZ_SECTIONS'
export const LIST_USER_QUIZ_ANSWERS = 'LIST_USER_QUIZ_ANSWERS'
export const USER_QUIZ_ANSWER = 'USER_QUIZ_ANSWER'
export const LIST_USER_QUIZ_BY_PACKAGE_ID = 'LIST_USER_QUIZ_BY_PACKAGE_ID'
export const SELECTED_SECTION_ID = 'SELECTED_SECTION_ID'
export const SELECTED_SECTION = 'SELECTED_SECTION'
export const RE_RENDER_QUIZ_PAGINATION = 'RE_RENDER_QUIZ_PAGINATION'
export const RE_RENDER_QUIZ_PARA = 'RE_RENDER_QUIZ_PARA'
export const GET_USER_QUIZ_FOR_STARTED_AT = 'GET_USER_QUIZ_FOR_STARTED_AT'


// REVIEW
export const GET_SINGLE_QUESTION = 'GET_SINGLE_QUESTION'
export const REVIEW_SELECTED_ANSWER = 'REVIEW_SELECTED_ANSWER'
export const QUESTION_ID_REVIEW = 'QUESTION_ID_REVIEW'
export const USER_QUIZ_ANSWER_SUBMITTED = 'USER_QUIZ_ANSWER_SUBMITTED'
export const SAVE_REVIEW_STEP = 'SAVE_REVIEW_STEP'
export const SAVE_USER_QUIZ_ID_FOR_REVIEW = 'SAVE_USER_QUIZ_ID_FOR_REVIEW'
export const SAVE_REVIEW_RESPONSE = 'SAVE_REVIEW_RESPONSE'
export const SAVE_IS_REVIEW_NEW = 'SAVE_IS_REVIEW_NEW'
export const RESET_REVIEW_REDUCER = 'RESET_REVIEW_REDUCER'
export const SAVE_REVIEW_TAGS = 'SAVE_REVIEW_TAGS'
export const SAVE_REVIEW_TAGS_RESPONSE = 'SAVE_REVIEW_TAGS_RESPONSE'
export const SAVE_REVIEW_FEEDBACK_STATUS = 'SAVE_REVIEW_FEEDBACK_STATUS'

// DASHBOARD
export const STUDENT_SELECTED_SECTION_BEFORE_REVIEW = 'STUDENT_SELECTED_SECTION_BEFORE_REVIEW'